"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var baseRoute = '/templates-service/v1';
exports.Routes = {
    ZPL_PRINTER: "".concat(baseRoute, "/printer/zpl"),
    TEMPLATES: "".concat(baseRoute, "/templates"),
    TEMPLATE: "".concat(baseRoute, "/templates/{:id}"),
    SEND_TEST_EMAIL: "".concat(baseRoute, "/send-email/test")
};
//# sourceMappingURL=Templates.consts.js.map